import { render } from "./Gateways.vue?vue&type=template&id=03337718&ts=true"
import script from "./Gateways.vue?vue&type=script&setup=true&lang=ts"
export * from "./Gateways.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/style-five/Gateways.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03337718"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03337718', __exports__)) {
    api.reload('03337718', __exports__)
  }
  
  module.hot.accept("./Gateways.vue?vue&type=template&id=03337718&ts=true", () => {
    api.rerender('03337718', render)
  })

}


export default __exports__